export const LAST_USED_ACCOUNT_STORAGE_KEY = 'lastUsedAccount';
